import { Box } from '@factorialco/deprecated-design-system'
import { CoCreationForm, CoCreationFormElement } from '@factorialco/f0-react/dist/experimental'
import { runInAction } from 'mobx'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import {
  FromFormToQuestionnaire,
  FromQuestionnaireToForm,
} from 'modules/forms/components/newFormEditor/helpers'
import 'modules/trainings/components/content/index.styles.css'
import {
  quizBlockToQuestionnaire,
  updateQuizBlockFromQuestionnaire,
} from 'modules/trainings/components/content/items/quiz/FormQuizHelper'
import { InlineEditableSimpleDescription } from 'modules/trainings/components/content/items/shared/fields/InlineEditableSimpleDescription'
import { InlineEditableTitle } from 'modules/trainings/components/content/items/shared/fields/InlineEditableTitle'
import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { QuizBlock } from 'modules/trainings/lib/content/QuizBlock'

const QuizBlockView = observer(
  ({ contentItem: quiz, onContentChange }: ContentEditorProps<QuizBlock>) => {
    const questionnaire = quizBlockToQuestionnaire(quiz)
    const elements = FromQuestionnaireToForm(questionnaire.elements)

    const handleTitleChange = (value: string) => {
      quiz.title = value
      onContentChange()
    }

    const handleDescriptionChange = (value: string) => {
      quiz.description = value
      onContentChange()
    }

    const handleChange = (updatedElements: CoCreationFormElement[]) => {
      const updatedQuestionnaire = {
        ...questionnaire,
        elements: FromFormToQuestionnaire(updatedElements),
      }

      runInAction(() => {
        updateQuizBlockFromQuestionnaire(quiz, updatedQuestionnaire)
      })

      onContentChange()
    }

    return (
      <Box gap="s24" width="full" height="full" alignItems="center">
        <InlineEditableTitle
          value={quiz.title}
          placeholder={i18n.t('trainings.content.block.quiz.title_placeholder')}
          ariaLabel={i18n.t('trainings.content.block.quiz.title_label')}
          onChange={handleTitleChange}
          style={{}}
        />

        <InlineEditableSimpleDescription
          value={quiz.description || ''}
          placeholder={i18n.t('trainings.content.block.quiz.description_placeholder')}
          ariaLabel={i18n.t('trainings.content.block.quiz.description_label')}
          onChange={handleDescriptionChange}
        />

        <Box gap="s16" width="full" alignSelf="center" paddingBottom="s80">
          <CoCreationForm
            isEditMode
            elements={elements}
            onChange={handleChange}
            allowedQuestionTypes={['select', 'multi-select']}
          />
        </Box>
      </Box>
    )
  }
)

export default QuizBlockView
